module.exports = __webpack_public_path__ + "img/setp-line.a48ed3c1.png";